<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <h3 class="card-title">Import</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-lg-5">
            <div class="form-group">
              <label>Upload File</label>
              <div class="input-group">
                <input style="padding:4px;height:auto;line-height:inherit;" type="file" class="form-control" accept=".xls,.xlsx" id="importFile" v-on:change="onImportFileUpload1">
                <div class="input-group-append">
                  <button class="btn btn-sm btn-primary" type="button" v-on:click="importData">Import File</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <br />
              <a href="/Templates/CDC_SHAREHOLDER_IMPORT_SAMPLE.xlsx" download="CDC_SHAREHOLDER_IMPORT_SAMPLE.xlsx" class="btn btn-outline-success btn-sm">Download Sample File</a>
            </div>
          </div>
        </div>
        <div class="row" v-if="CDCShareHolder.length">
          <div class="col-md-6">
            <strong>Total Entries:</strong> {{ CDCShareHolder.length }}
          </div>

          <div class="col-md-6 text-right">
            <strong>Total Share Held:</strong> {{ formatNumber(totalShares) }}
          </div>
        </div>
        <div class="row" v-if="CDCShareHolder.length">
          <div class="col-md-12">
            <label>CDC ShareHolder List</label>
            <div class="col-lg-12">
              <div class="table-responsive">
                <table class="table table-bordered table-sm table-hover " width="100%">
                  <thead>
                    <tr class="bg-custom" style="color:white">
                      <td width="2%">Sr.</td>
                      <th width="4%">Folio No.</th>
                      <th width="15%">Name</th>
                      <th width="25%">Address</th>
                      <th width="5%">Share Held</th>
                      <th width="10%">CNIC No</th>
                      <th width="10%">Mobile No.</th>
                      <th width="10%">Email Address</th>
                      <th width="5%">CDC Y/N</th>
                      <th width="5%">As on Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, ind) in CDCShareHolder">
                      <td>{{ind + 1}}</td>
                      <td>{{item.FOLIO_NO}}</td>
                      <td>{{item.NAME}}</td>
                      <td>{{item.ADDRESS}}</td>
                      <td style="text-align:right">{{formatNumber(item.SHARE_HELD)}}</td>
                      <td>{{item.CNIC_NO}}</td>
                      <td>{{item.MOBILE_NO}}</td>
                      <td>{{item.EMAIL_ADDRESS}}</td>
                      <td>{{item.CDC_YN}}</td>
                      <td>{{trimDate(item.AS_ON_DATE)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" class="btn btn-success btn-sm float-right" v-if="fileImported" v-on:click="save()">Save</button>
        <button class="btn btn-primary btn-sm" v-on:click="back()" type="button">Back To List</button>
      </div>
    </div>

  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        fileImported: false,
        CDCShareHolder: [],
        importFile: "",
      }
    },
    updated: function () {
      $("#tbl").DataTable();
    },
    computed: {
      totalShares() {
        return this.CDCShareHolder.reduce((sum, item) => {
          return sum + (item.SHARE_HELD || 0);
        }, 0);
      }
    },
    methods: {

      onImportFileUpload1: function (event) {
        if (this.checkFile(event.target.files[0])) {
          startReq();
          var reader = new FileReader;
          reader.onload = (e) => {
            this.importFile = e.target.result
          }
          reader.readAsDataURL(event.target.files[0]);
          endReq();
        }
        else {
          $('#importFile').val('');
        }
      },
      importData() {
        if (!this.importFile) {
          toastr.error("No file uploaded");
          return;
        }
        startReq();
        var vm = this;
        axios.post("/api/UICApi/CDCShareHolderImport", {
          File: vm.importFile,
        })
          .then(function (res) {
            $('#importFile').val('');
            endReq();
            if (res.data.status) {
              toastr.success("File Uploaded");
              vm.fileImported = true;
              vm.CDCShareHolder = res.data.CDCShareHolder;
            }
            else {
              toastr.error(res.data.msg);
              vm.fileImported = false;
              vm.CDCShareHolder = [];
            }
          })
          .catch(function (error) {
            endReq();
            vm.CDCShareHolder = [];
            vm.fileImported = false;
            $('#importFile').val('');
          });
      },

      checkFile(file) {
        if (file == null) {
          return false;
        }
        if (file.type != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
          toastr.error("invalid file only excel sheet is allowed");
          return false;
        }
        toastr.success("Uploaded", "Done!");
        return true;
      },
      remove(ind) {
        this.orderTemplate.splice(ind, 1);
      },
      preview() {
        $("#edu").modal("show");
      },
      save() {
        var vm = this;
        startReq();
        axios.post("/api/UICApi/saveCDCShareHolderImport", {
          CDCShareHolder: vm.CDCShareHolder,
          File: vm.importFile,
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success(res.data.msg);
              vm.importFile = "";
              vm.CDCShareHolder = [];
              //    vm.back();
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      back() {
        window.location.href = '/UIC/CDCShareHolderList';
      },
      formatNumber(num) {
        return num ? Math.round(num).toLocaleString() : "0";
      },
      trimDate(date) {
        return date ? date.split('T')[0] : '';
      }
    }
  };
</script>

<style scoped>
  .btn-xs {
    padding: 0.125rem 0.25rem;
    font-size: .75rem;
    line-height: 1.0;
    border-radius: 0.15rem;
  }

  .table {
    width: 100%;
    table-layout: fixed;
  }

  .form-control {
    height: calc(1.8125rem + 2px);
    padding: .25rem .5rem;
    font-size: 12px;
    line-height: 1.5;
    border-radius: .2rem;
  }
</style>






// WEBPACK FOOTER //
// src/components/ims/CDCShareHolderImport.vue